type LogoProps = {
  mode?: 'logo'|'title'
}

export const Logo = ({ mode = 'logo' }: LogoProps) => {
  return (
    <a href="#" className="inline-grid justify-start font-medium relative logo-root">
      {/* <span className={`w-14 col-start-1 row-start-1 flex items-center transition-all origin-center duration-200 ${mode === 'logo' ? 'opacity-100 scale-100 delay-75' : 'opacity-0 scale-90 delay-0 pointer-events-none'}`}> */}
      <span className={`w-14 col-start-1 row-start-1 flex items-center transition-all origin-left duration-500 logo-swap ${mode === 'logo' ? 'opacity-100 scale-100 delay-75 ' : 'opacity-100 scale-75 delay-0'}`}>
        <img src="/logomark.png" className="max-w-14" />
      </span>
      <span className={`col-start-2 row-start-1 flex items-center transition-all translate-x-[-4px] logo-swap ${mode === 'title' ? 'opacity-100 translate-y-0 delay-75 duration-500 ' : 'opacity-0 translate-y-[40px] delay-0 duration-200 pointer-events-none'}`}>
        <h2 className="text-lg font-semibold text-foreground tracking-tight ">Data Sharing License</h2>
      </span>
    </a>
  )
}
